import AreaContainer from "../AreaContainer";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import { useRef, useState } from "react";

import styles from './availability.module.css';
import globalStyles from '../result.module.css';
import buttons from "components/_styled/buttons.module.css";
import logEvent from "lib/ga/miscEvent"


interface Props {
  propertyUrl: string;
  name: string;
  size_ft_max: string;
  tenantName: string;
  isAvail: boolean;
  toLet: boolean;
  availability: string;
  rent: string;
}

interface MainProps {
  properties: any;
  title: string;
  area: string;
  brandingColor: string;
  isAvail: boolean;
  parentUrl?: string;
}


const PropertyTable = ({ properties, title, area, brandingColor, isAvail, parentUrl }: MainProps) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <AreaContainer area={area} style={null} extraClass={null}>
      <div className={styles.AvailibilityWrapper}>
        <h2 className={globalStyles.subTitleText}>{title}</h2>
        <TableContainer>
          <Table sx={{ maxWidth: '100%', borderRadius: '10px', overflow: 'hidden' }} aria-label="simple table">
            <TableHead sx={{ minWidth: 650 }}>
              <TableRow sx={{ backgroundColor: brandingColor || '#941E3A' }}>
                <TableCell sx={{ color: 'white', fontSize: '18px' }}>Unit</TableCell>
                <TableCell sx={{ color: 'white', fontSize: '18px' }}>{isAvail ? "Status" : "Tenant"}</TableCell>
                <TableCell className={styles.size} sx={{ color: 'white', fontSize: '18px' }}>Size</TableCell>
                {isAvail && <TableCell className={styles.size} sx={{ color: 'white', fontSize: '18px' }}>Rent</TableCell>}
                {isAvail && <TableCell aria-label="property links"></TableCell>}
              </TableRow>
            </TableHead>
            <TableBody className={styles.table}>

              {(rowsPerPage > 0
                ? properties.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : properties
              ).map((property) => {
                let propertyUrl = null;
                if (isAvail) {
                  propertyUrl = `/scheme/${parentUrl}/property/${property.url_fragment ? property.url_fragment : property.id}`;
                }
                return (
                  <PropertyRowDisplay
                    key={property.id}
                    propertyUrl={propertyUrl}
                    name={property.name}
                    size_ft_max={property.size_ft_max}
                    tenantName={property.tenant_name} isAvail={isAvail}
                    toLet={property.availability == "To Let"}
                    availability={property.availability} rent={property.rent_pa} />
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={properties.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          className={styles.pagination}
        />
      </div>
    </AreaContainer>
  )
}

const PropertyRowDisplay = ({ propertyUrl, name, size_ft_max, tenantName, isAvail, toLet, availability, rent }: Props) => {

  const resultLinkRef = useRef<HTMLAnchorElement>(null);

  return (
    <TableRow
      onClick={(e) => {
        if (
          propertyUrl
        ) {
          resultLinkRef?.current?.click();
        }
      }}
      className={isAvail ? styles.AvailableProps : ''}
    >
      <TableCell>{name}</TableCell>
      <TableCell>{isAvail ? <div className={styles.availabilityStatus} >{availability}</div> : tenantName}</TableCell>
      <TableCell className={styles.size}>{size_ft_max ? parseFloat(size_ft_max).toLocaleString() + " sq ft" : "-"}</TableCell>
      
      {isAvail && (
        <>
        <TableCell className={styles.size}>{ rent ? `£${parseInt(rent).toLocaleString()} pa` : "-"} </TableCell>
        <TableCell>

          <a className={`${buttons.primaryButton}`} ref={resultLinkRef} onClick={() => {
            if (propertyUrl) {
              logEvent({
                category: "Scheme Availability",
                action: "Property Link",
                label: `Property: ${name}`,
              });}}} href={propertyUrl}>
           <span className={styles.size}>View {name}</span> <span className={styles.hideDesk}>View</span>
          </a>
        </TableCell>
        </>
       
      )}
    </TableRow>
  );
}

export default PropertyTable
